import { useCallback, useState } from 'react';

import { stripHtmlTags } from '@change-corgi/core/html';

import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';

import type { Comment } from '../../../../../../types';

type Result = ModelHookResult<
	{
		comment: string;
		commentUrl: string;
		expanded: boolean;
	},
	{
		expandComment: () => void;
	}
>;

export function useCommentCard({ id, comment }: Comment): Result {
	const [expanded, setExpanded] = useState(false);
	const {
		data: {
			petition: { slug },
		},
	} = useStarterDashboardV2PageData();

	return {
		data: {
			// some comments somehow contain links in HTML format
			comment: stripHtmlTags(comment),
			commentUrl: `/p/${encodeURIComponent(slug)}/c/${id}`,
			expanded,
		},
		actions: {
			expandComment: useCallback(() => setExpanded(true), []),
		},
	};
}
